.sectionContainer {
    border: 1px solid var(--static-divider-standard);
    padding: 1rem;
    border-radius: 12px;
    background-color: var(--static-background-strong);
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
    z-index: 0;
}

.sectionHeader {
    font-size: var(--fs-small-heading);
    font-weight: 600;
    color: var(--static-text-strong);
    line-height: normal;
}

.sectionHeaderContainer {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 1rem;
}

.sectionIcon {
    color: var(--static-text-strong);
}

.metricContainer {
    display: flex;
    gap: 2rem;
    /* align-items: center; */
    width: 100%;
}


.card {
    border: 1px solid var(--static-divider-standard);
    padding: 1rem;
    border-radius: 12px;
    background-color: var(--static-background-strong);
    display: flex;
    flex-direction: column;
    /* flex: 1;
    min-width: 0; */
}

.miniStatsCard {
    flex: 1
}

.grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr); /* Creates 2 equal columns */
    /* grid-template-rows: repeat(2, 1fr); */
    gap: 1rem;
    margin-top: 1rem;
}

.grid-item {
    /* border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    padding: 20px; */
    /* width: 50%;
    height: 50% */
}

.subTitle {
    font-size: var(--fs-x-small);
    color: var(--static-text-standard);
    font-weight: 400;
    line-height: 1rem;
}

.displayValue {
    font-size: var(--fs-small-heading);
    color: var(--static-text-strong);
    font-weight: 600;
    line-height: normal;
}


.percentageBadge {
    display: inline-flex;
    align-items: center;
    padding: 0rem 0.375rem;
    border-radius: 6px;
    gap: 0.25rem;
  }
  
.rising {
    background-color: var(--sentiment-background-positive);
}

.falling {
    background-color: var(--sentiment-background-negative);
}

.percentageIcon {
    /* margin-right: 0.25rem; */
}

.percentageIconFalling {
    fill: #CD0710
}

.percentageText {
    font-size: 16px;
}

.rising .percentageText {
    color: #16a34a;
}
  
.falling .percentageText {
    color: #dc2626;
}

.divider {
    margin-top: 16px;
    margin-bottom: 16px;
}

.infoBanner {
    margin-bottom: 16px;
}

.comparisionRange {
    margin-bottom: 1rem;
}
